import { createStyles, makeStyles } from '@material-ui/core/styles';
import useMulticurrencyToPrice from '@sprinx/react-globalize/useMulticurrencyToPrice';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import PercentFieldPreview from '@sprinx/react-mui-fields/PercentFieldPreview';
import PriceFieldPreview from '@sprinx/react-mui-fields/PriceFieldPreview';
// import TextFieldPreview from '@sprinx/react-mui-fields/TextFieldPreview';
import clsx from 'clsx';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { currencyState, isAuthenticatedState } from '../../../api/appState';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface ProductDetailOtherPricesProps extends StandardDivProps<ProductDetailOtherPricesClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailOtherPricesClassKey = 'root' | 'field' | 'label' | 'textLeft';

const themeSettings = { name: 'ProductDetailOtherPrices' };
const useStyles = makeStyles(
  (theme) =>
    createStyles<ProductDetailOtherPricesClassKey, {}>({
      root: {
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
          flexWrap: 'wrap',
          '& > div': {
            width: '50%',
          },
        },
      },
      label: {
        '& label': { fontSize: 12, transform: 'none', transfromOrigin: 'none' },
        '& > div': {
          justifyContent: 'flex-end',
        },
      },
      textLeft: {
        '& label': { textAlign: 'left' }, // 'textAlign' is deprecated. Use 'textAlign' instead.ts(6387)
      },
      field: {
        width: 'auto',
        minWidth: 'unset',
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
          marginRight: 0,
          padding: theme.spacing(0, 1),
        },
      },
    }),
  themeSettings,
);

const ProductDetailOtherPrices = React.forwardRef<HTMLDivElement, ProductDetailOtherPricesProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const currency = useRecoilValue(currencyState);
    const isAuthenticated = useRecoilValue(isAuthenticatedState);
    const getPrice = useMulticurrencyToPrice(currency);
    // const customerRegion = useRecoilValue(customerRegionState);
    const t = useTranslateWithFallback();

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        {/* <NumberFieldPreview
          label={t('productPage/minOrderableQuantity')}
          value={product.quantityMin || 1}
          size='small'
          align='right'
          decimalPrecision={0}
          alignLabel
          className={clsx(classes.field, classes.label)}
        /> */}
        {/* <TextFieldPreview
          label={t('cataloguePage/item/package')}
          value={(customerRegion === 'SK' ? product.extra?.packSizeTextSK : product.extra?.packSizeTextCZ) || ''}
          size='small'
          align='right'
          alignLabel
          className={clsx(classes.field, classes.label)}
        /> */}
        {isAuthenticated && (
          <PercentFieldPreview
            label={t('common/vat')}
            value={product?.taxInfo?.value || 0}
            size='small'
            className={clsx(classes.field, classes.label, classes.textLeft)}
            alignLabel
            align='right'
          />
        )}
        {product.msiPriceWithTax && (
          <PriceFieldPreview
            label={t('common/vatDMIC')}
            value={getPrice(product.msiPriceWithTax)}
            currency={currency}
            className={clsx(classes.field, classes.label)}
            size='small'
            align='right'
            alignLabel
          />
        )}
        {product.msrPriceWithTax && (
          <PriceFieldPreview
            label={t('common/vatDMOC')}
            value={getPrice(product.msrPriceWithTax)}
            currency={currency}
            className={clsx(classes.field, classes.label)}
            size='small'
            align='right'
            alignLabel
          />
        )}
        {product.priceOriginalWithTax && (
          <PriceFieldPreview
            label={t('common/basePriceWithTax')}
            value={product.priceOriginalWithTax}
            currency={currency}
            className={clsx(classes.field, classes.label)}
            size='small'
            align='right'
            alignLabel
          />
        )}
        {product.priceOriginal && (
          <PriceFieldPreview
            label={t('common/basePriceWithoutTax')}
            value={product.priceOriginal}
            currency={currency}
            className={clsx(classes.field, classes.label)}
            size='small'
            align='right'
            alignLabel
          />
        )}
      </div>
    );
  },
);

ProductDetailOtherPrices.displayName = 'ProductDetailOtherPrices';

export default withThemeProps(themeSettings)(ProductDetailOtherPrices);
